'use strict';

/**
 * Canonical HD derivation paths for the three Web3Keys roles (BIP44).
 *
 *   m / 44' / coin' / account' / change / index
 *
 * - identity        : BSV (coin 236), account 0 — signs attestations / DID control.
 * - finance         : BTC (coin 0),   account 0 — the Bitcoin financial key.
 * - tokensOrdinals  : BSV (coin 236), account 2 — tokens & 1Sat ordinals.
 *
 * Note: finance intentionally uses coin type 0 (real Bitcoin), the others use 236 (BSV).
 * P2PKH address encoding is identical across both (version byte 0x00); only the path differs.
 */
const PATHS = Object.freeze({
  identity: "m/44'/236'/0'/0/0",
  finance: "m/44'/0'/0'/0/0",
  tokensOrdinals: "m/44'/236'/2'/0/0",
});

/**
 * Derive the three role private keys from a SmartLedger HD root.
 * @param {object} hd - bsv.HDPrivateKey (from mnemonic.toHDPrivateKey()).
 * @returns {{identity: PrivateKey, finance: PrivateKey, tokensOrdinals: PrivateKey}}
 */
function deriveRoleKeys(hd) {
  return {
    identity: hd.deriveChild(PATHS.identity).privateKey,
    finance: hd.deriveChild(PATHS.finance).privateKey,
    tokensOrdinals: hd.deriveChild(PATHS.tokensOrdinals).privateKey,
  };
}

module.exports = { PATHS, deriveRoleKeys };
